import React from 'react';
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Avatar,
  Typography,
  Button,
  Icon,
} from '@material-ui/core';
import { useStyles } from './styles';
import { formatPhone } from 'utils/converters';

export default function ContainerCollapse({
  rowData,
  pagination = {},
  prevPage,
  nextPage,
  selectedSituationStatusList = [],
}) {
  const classes = useStyles();

  const {
    has_prev = false,
    has_next = false,
    current_page = 1,
    total_pages = 1,
  } = pagination;

  return (
    <div>
      {rowData?.length > 0 ? (
        <>
          <Table className={classes.table}>
            <TableHead className={classes.table}>
              <TableRow className={classes.table}>
                <TableCell>Imagem</TableCell>
                <TableCell>Nome</TableCell>
                <TableCell>CPF</TableCell>
                <TableCell>Email</TableCell>
                <TableCell>Telefone</TableCell>
                <TableCell>RG</TableCell>
                <TableCell>Grupo</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rowData
                .filter(
                  (item) =>
                    selectedSituationStatusList.length === 0 ||
                    selectedSituationStatusList.find(
                      (selected) =>
                        `${selected?.id}` ===
                        `${item?.situation}${item?.situation_status}`
                    )
                )
                .map((item, index) => (
                  <TableRow key={index} className={classes.root}>
                    <TableCell>
                      <Avatar
                        src={item?.image_url}
                        alt={item?.name || 'Usuário'}
                        className={classes.avatar}
                      />
                    </TableCell>
                    <TableCell>
                      <Typography variant="body1">
                        {item?.name || 'Usuário não identificado'}
                      </Typography>
                    </TableCell>
                    <TableCell>{item?.cpf}</TableCell>
                    <TableCell>{item?.email}</TableCell>
                    <TableCell>{formatPhone(item?.cell_phone)}</TableCell>
                    <TableCell>{item?.rg}</TableCell>
                    <TableCell>{item?.group?.name}</TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </>
      ) : (
        <Typography variant="body2" style={{ padding: 16 }}>
          Nenhum histórico encontrado para este dispositivo.
        </Typography>
      )}

      <div className={classes.buttonContainer}>
        <Button onClick={prevPage} disabled={!has_prev} style={{ padding: 0 }}>
          <Icon>keyboard_arrow_left</Icon>
        </Button>
        {has_prev && <p style={{ margin: 0 }}>1</p>}
        {has_prev && (
          <p style={{ margin: 0, marginLeft: 16, marginRight: 16 }}>...</p>
        )}
        <p style={{ margin: 0 }}>{current_page}</p>
        {has_next && (
          <p style={{ margin: 0, marginLeft: 16, marginRight: 16 }}>...</p>
        )}
        {has_next && total_pages > current_page && (
          <p style={{ margin: 0 }}>{total_pages}</p>
        )}
        <Button onClick={nextPage} disabled={!has_next} style={{ padding: 0 }}>
          <Icon>keyboard_arrow_right</Icon>
        </Button>
      </div>
    </div>
  );
}
